<div class="form-check form-switch">
  <input
    class="form-check-input switch"
    [id]="'chk_' + id"
    type="checkbox"
    role="switch"
    [disabled]="isDisabled"
    (ngModelChange)="valueChanged($event)"
    [ngModel]="value" />
  <label *ngIf="label != null" class="form-check-label" [for]="'chk_' + id">{{ label }}</label>
</div>
